import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from '../../services/app-config.service';
import { LoginBean } from '../../shared/models/login-bean.model';
import { ConnexionBean } from '../models/connexion-bean.model';
import { DetailEtude } from '../models/detail-etude.model';
import { RestService } from './rest.service';

/**
 * Accès REST concernant à l'authentification
 */
@Injectable()
export class AuthService extends RestService {

    constructor(
        private readonly http: HttpClient
      ) {
        super();
      }
    /**
     * Webservice de connexion à lidia par le login legacy (par lidia)
     *
     * @param body
     * @returns {Observable<any>}
     */
    legacyLogin(loginBean: LoginBean): Observable<ConnexionBean> {
      const heads = this.createAuthorizationHeader('json');
      const url = `${AppConfigService.settings.urlServeur}rest/auth/connect/lidia/`;
      return this.http.post<ConnexionBean>(url, JSON.stringify(loginBean), {headers: heads});
    }

    /**
     * Vérifier si login est un notaire
     *
     * @param login nom du login
     * @returns {Observable<boolean>}
     */
    getNotaireInformation(login: string): Observable<DetailEtude> {
      const url = `${AppConfigService.settings.urlServeur}rest/auth/notaire/info/?login=${login}`;
      return this.http.get<DetailEtude>(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts